import { resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { computed, defineComponent, useCssModule, provide, ref, onMounted, onUnmounted, onActivated, onDeactivated } from "vue";
import { Btn, Icon } from "linkd-ui";
import YQueryItem1 from "./YQueryItem.vue";
const YQueryItem = YQueryItem1;
import { useRoute } from "vue-router";
export default defineComponent({
  props: {
    searchText: {
      type: String,
      default: "查询"
    },
    hasSearchButton: {
      type: Boolean,
      default: true
    },
    flexEnd: {
      type: Boolean,
      default: false
    },
    spaceBetween: {
      type: Boolean,
      default: true
    },
    equal: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    },
    gutter: {
      type: String,
      default: ""
    }
  },
  components: {
    Btn,
    Icon,
    YQueryItem
  },
  setup(props, ctx) {
    const css = useCssModule("css");
    const visible = ref(false);
    //类名设置
    const queryClass = computed(() => {
      return {
        [css.query]: true,
        query_box: true,
        [css.expanded]: !visible.value,
        [css.flex_end]: props.flexEnd,
        [css.space_between]: props.spaceBetween
      };
    });
    //内容显示
    const content = computed(() => {
      //筛选的展开与收起
      let moreFilter = _createVNode("div", {
        "class": css.cursor,
        "onClick": () => visible.value = !visible.value
      }, [_createTextVNode("\u66F4\u591A\u7B5B\u9009"), _createVNode(Icon, {
        "name": "w-icon-arrow-down",
        "rotate": visible.value,
        "color": "#aaa"
      }, null)]);
      //query里的内容
      let querycontent = [props.hasSearchButton ? _createVNode(_resolveComponent("y-query-item"), null, {
        default: () => [_createVNode(Btn, {
          "type": "primary",
          "onClick": el => {
            ctx.emit("search");
          }
        }, {
          default: () => [props.searchText]
        })]
      }) : null, ctx.slots.append?.(), (ctx.slots.default?.() || []).length > (document.querySelectorAll(".w-mask").length > 0 ? 1 : 2) ? _createVNode(_resolveComponent("y-query-item"), null, {
        default: () => [_createTextVNode(" "), moreFilter]
      }) : null];
      if (props.spaceBetween) {
        querycontent = [_createVNode("div", {
          "class": css.otherLine
        }, [ctx.slots.default?.()]), _createVNode("div", {
          "class": [css.q, css.bottom]
        }, [querycontent])];
      }
      return querycontent;
    });
    const tableBox = ref();
    const isFromCache = ref(false);
    const route = useRoute();
    let routeQueryTs = route.query.ts;
    onMounted(() => {
      // 设置标志位为 true 表示组件已加载
      if (routeQueryTs) {
        sessionStorage.setItem("hasYQueryComponent-" + routeQueryTs, "1");
      } else {
        sessionStorage.removeItem("hasYQueryComponent-" + routeQueryTs);
      }
    });
    onUnmounted(() => {
      sessionStorage.removeItem("hasYQueryComponent-" + routeQueryTs);
    });
    onActivated(() => {
      if (isFromCache.value) {
        //解决刷新，请求2次接口的问题
        ctx.emit("search");
      }
    });
    onDeactivated(() => {
      isFromCache.value = true;
      //   sessionStorage.removeItem("hasYQueryComponent-" + routeQueryTs);
    });
    //子组件的通信
    provide("size", props.size);
    provide("equal", props.equal);
    return () => _createVNode("div", {
      "style": {
        marginBottom: props.gutter
      },
      "class": queryClass.value,
      "ref": tableBox
    }, [content.value]);
  }
});